export default __webpack_public_path__ + "static/media/ic_danger_alert.e1ac70c5.svg";